import { categories } from "@/mocks/feed";

const navLinks = [
  { href: "#breaking", label: "前线在线" },
  { href: "#hot", label: "今日热榜" },
  { href: "#feed", label: "前线爆料" },
  { href: "#chain", label: "事件链条" },
  { href: "#faq", label: "前线问答" },
  { href: "#about", label: "关于我们" },
];

const catLinks = categories.filter((c) => c.id !== "all");

export default function Footer() {
  const scroll = (href: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById(href.replace("#", ""))?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="w-full bg-secondary-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#top" onClick={scroll("#top")} className="flex items-center gap-2.5 whitespace-nowrap cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-eye-2-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="leading-tight">
                <span className="block font-heading text-base font-extrabold tracking-tight text-foreground-950">吃瓜前线</span>
                <span className="font-script block text-[10px] leading-none text-primary-700">GUA · FRONTLINE</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              吃瓜前线守候第一现场：一手实拍、目击细节、原发经过，不靠二手转述。热点持续上线，想看完整事件链随时回刷，这里永远有新的爆点。
            </p>
          </div>

          <nav className="lg:col-span-2" aria-label="页脚导航">
            <h3 className="text-sm font-bold text-foreground-950">快速直达</h3>
            <ul className="mt-3 space-y-2">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} onClick={scroll(l.href)} className="text-sm text-foreground-700 transition-colors hover:text-primary-700 cursor-pointer">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="lg:col-span-3" aria-label="栏目导航">
            <h3 className="text-sm font-bold text-foreground-950">前线栏目</h3>
            <ul className="mt-3 space-y-2">
              {catLinks.map((c) => (
                <li key={c.id}>
                  <a href="#feed" onClick={scroll("#feed")} className="text-sm text-foreground-700 transition-colors hover:text-primary-700 cursor-pointer">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="lg:col-span-2">
            <h3 className="text-sm font-bold text-foreground-950">联系我们</h3>
            <ul className="mt-3 space-y-2 text-sm text-foreground-700">
              <li>
                <a href="mailto:report@guafront.cn" className="flex items-center gap-1.5 transition-colors hover:text-primary-700 cursor-pointer">
                  <i className="ri-send-plane-line" aria-hidden="true"></i> 爆料投稿
                </a>
              </li>
              <li>
                <a href="mailto:hello@guafront.cn" className="flex items-center gap-1.5 transition-colors hover:text-primary-700 cursor-pointer">
                  <i className="ri-mail-line" aria-hidden="true"></i> 商务合作
                </a>
              </li>
              <li>
                <a href="#about" onClick={scroll("#about")} className="flex items-center gap-1.5 transition-colors hover:text-primary-700 cursor-pointer">
                  <i className="ri-heart-line" aria-hidden="true"></i> 加入我们
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-background-300/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">© 2026 吃瓜前线 GUA FRONTLINE · 理性吃瓜，快乐回刷</p>
          <p className="text-xs text-foreground-500">本站为网络热点信息聚合整理平台，内容仅供参考。</p>
        </div>
      </div>
    </footer>
  );
}